// extracted by mini-css-extract-plugin
module.exports = {"cardOval":"admin-kpi_cardOval__4fZho","containerKPI":"admin-kpi_containerKPI__46CqH","buttonList":"admin-kpi_buttonList__iwidW"};